import { Tag } from 'antd'
import { colorBgBrandless } from 'src/app/themes/primaryThemeDefault'

interface TagProps {
  value: string
}

export const PrimaryTag: React.FC<TagProps> = ({ value }) => {
  return (
    <Tag
      style={{
        backgroundColor: colorBgBrandless,
        border: 'none',
        padding: '4px 8px',
        borderRadius: 4,
        fontWeight: 400,
        lineHeight: '20px',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
      }}
    >
      {value}
    </Tag>
  )
}
